import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, defineAsyncComponent, onBeforeMount, watch } from "vue";
import ModalComponent from "@/components/modal/modalComponent.vue";
import { OrderSearchType, PaytrailReturnStatus } from "./type";
import { IUseFetchDetailError } from "@/hook/fetch/interface";
import { AllFilterOrders } from "@/store/modules/Orders/type";
import { SeoDescription, SeoTitle } from "@/utils/seo/seo";
import { getOrders } from "./fetch/getOrdersFilter";
import { IStore } from "@/store/types/StoreType";
import { useFetch } from "@/hook/fetch/fetch";
import { useForm } from "vee-validate";
import { useRouter } from "vue-router";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersView',
  setup(__props) {

const OrderRangeComponent = defineAsyncComponent(
  () => import("./ordersRangeDate/orderRangeComponent.vue")
);
const AdvertisingComponent = defineAsyncComponent(
  () => import("./advertising/advertisingComponent.vue")
);
const AllOrderComponent = defineAsyncComponent(
  () => import("./allOrders/allOrderComponent.vue")
);

const store = useStore<IStore>();
const filter = ref(
  computed<AllFilterOrders>(() => store.getters.getOrdersFilter || {})
);

const { handleSubmit, handleReset } = useForm<OrderSearchType>({
  initialValues: {
    status__id: "",
    priority: "",
    order_nav: "",
    number__icontains: "",
    update__gte: "",
    date__gte: "",
    date__lte: "",
    update__lte: "",
    page_size: "",
    ordering: "",
    order_btn: "",
    position: "",
    ...filter.value,
  },
  validationSchema: {},
});

const router = useRouter();

const close = () => {
  if (modal.value.smallText === "Payment was successful!") {
    onSubmit();
    router.push({ path: "orders", replace: true });
    return (modal.value.modal = false);
  }
  switch (modal.value.message) {
    case "An error has occurred, please reload the page":
      return router.replace({ query: undefined }).then(() => {
        location.reload();
      });
    case "Sorry, payment failed, please try again":
      return router.push({ path: "cart", replace: true });
  }
};

const onSubmit = handleSubmit((values) => getOrders(values));
const autoUpdate = handleSubmit((values) => getOrders(values, true));
const modal = ref({
  modal: false,
  number: "",
  message: "",
  smallText: "",
  isLoading: true,
});

onBeforeMount(async () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (
    urlParams.has("checkout-reference") &&
    urlParams.has("checkout-transaction-id") &&
    urlParams.has("checkout-status")
  ) {
    const query =
      "?checkout-transaction-id=" +
      urlParams.get("checkout-transaction-id") +
      "&checkout-reference=" +
      urlParams.get("checkout-reference");
    modal.value.modal = true;
    if (urlParams.get("checkout-status") === "fail") {
      const { isLoading } = await useFetch<
        PaytrailReturnStatus,
        IUseFetchDetailError
      >(
        process.env.VUE_APP_SERVER + "api/paytrail/cancel/" + query,
        "GET",
        true
      );
      modal.value.isLoading = isLoading.value;
      modal.value.modal = true;
      modal.value.message = "Sorry, payment failed, please try again";
      return;
    }
    const { data, isLoading } = await useFetch<
      PaytrailReturnStatus,
      IUseFetchDetailError
    >(
      process.env.VUE_APP_SERVER + "api/paytrail/success/" + query,
      "GET",
      true
    );
    modal.value.isLoading = isLoading.value;
    modal.value.modal = true;
    if (data.value?.Result) modal.value.smallText = "Payment was successful!";
    else {
      modal.value.message = "An error has occurred, please reload the page";
      modal.value.smallText =
        "If this is not the first time you see this message, please contact the administrators";
    }
  }
});

watch(
  () => store.getters.getSelectedCurrency,
  () => {
    autoUpdate();
  }
);

const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));
onBeforeMount(() => {
  switch (uiLang.value.toUpperCase()) {
    case "SWEDISH":
      SeoTitle("Tyre point: Order");
      SeoDescription(
        "Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa."
      );
      break;
    case "FINLAND":
      SeoTitle("Tyre point: Tilaukset");
      SeoDescription(
        "Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa."
      );
      break;
    default:
      SeoTitle("Tyre point: Orders");
      SeoDescription(
        "The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe."
      );
      break;
  }
});

watch(
  () => uiLang.value,
  () => {
    switch (uiLang.value.toUpperCase()) {
      case "SWEDISH":
        SeoTitle("Tyre point: Order");
        SeoDescription(
          "Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa."
        );
        break;
      case "FINLAND":
        SeoTitle("Tyre point: Tilaukset");
        SeoDescription(
          "Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa."
        );
        break;
      default:
        SeoTitle("Tyre point: Orders");
        SeoDescription(
          "The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe."
        );
        break;
    }
  },
  {
    deep: true,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(AdvertisingComponent)),
    _createElementVNode("form", {
      onReset: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleReset) && _unref(handleReset)(...args))),
      onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
      class: "orders-form"
    }, [
      _createVNode(_unref(OrderRangeComponent), { onSubmit: _unref(autoUpdate) }, null, 8, ["onSubmit"]),
      _createVNode(_unref(AllOrderComponent), { onSubmit: _unref(onSubmit) }, null, 8, ["onSubmit"])
    ], 32),
    (modal.value.modal)
      ? (_openBlock(), _createBlock(ModalComponent, {
          key: 0,
          title: modal.value.message,
          smallText: modal.value.smallText,
          button_1: 'OK',
          callback1: close,
          isLoading: modal.value.isLoading
        }, null, 8, ["title", "smallText", "isLoading"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})